import { useTranslate } from '@tolgee/react';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';

import SchoolAndFreePlanContent from '../components/_organisms/SchoolAndFreePlanContent';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import {
  detectAndBestEffortSetLanguage,
  getLocaleRedirectIfNeeded,
} from '../utils/localisationUtils';

const SchoolAndFreePlanPage: NextPageWithLayout = () => {
  const { t } = useTranslate();
  const title = t('SchoolAndFreePlan.Meta.Title', 'Free vs School Plan — Curipod');
  const subTitle = t(
    'SchoolAndFreePlan.Meta.Description',
    'See what you get each week on the Curipod free plan, how School Plan Trials work, and how to bring Curipod to your whole school.',
  );

  return (
    <LandingPageLayout
      title={title}
      subTitle={subTitle}
      hideBlobs={true}
      disableHeadline={true}
    >
      <SchoolAndFreePlanContent />
    </LandingPageLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const localeRedirect = getLocaleRedirectIfNeeded(context, '/school-and-free-plan');
  if (localeRedirect) return localeRedirect;

  return {
    props: {
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

SchoolAndFreePlanPage.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default SchoolAndFreePlanPage;
